export default __webpack_public_path__ + "static/media/award_cover_2.ccd72527.png";